import React from 'react';
import {Link} from 'react-router-dom';
import styles from './EledoPricing.module.scss';
import {useErrorNotyf, useShowMenu} from "hooks";
import {
  EledoMainPageTitle, EledoError,
  EledoLoader, EledoPricingPlan
} from "components/library";
import classnames from "classnames";
import useCurrentPlan from 'graphql/hooks/useCurrentPlan';


const EledoPricing = () => {
  const { loading, error, currentPlan } = useCurrentPlan()

  useErrorNotyf(error);
  useShowMenu();

  const allplans = currentPlan?.availablePlans
  const currentLevel = currentPlan?.currentPlanLevel || 0
  const subscribedLevel = currentPlan?.nextPlan ? currentPlan?.nextPlanLevel : currentLevel
  const hasCustomPlan = allplans && allplans?.length > 4
  const hasCustomPlanNext = allplans && allplans?.length > 5
  const customPlan = hasCustomPlan ? allplans[4] : undefined
  const customPlanNext = hasCustomPlanNext ? allplans[5] : undefined

  const plans = allplans && allplans.slice(0, 4)

  const renderError = () =>
    <EledoError title={error?.message}
                description={(<React.Fragment>
                  We are sorry &#9785; We could not load any pricing plans. <br/><br/>
                  {error?.message.toLocaleLowerCase() === "network error" && "Please check your internet connection."}
                </React.Fragment>)}/>;

  const renderPlans = () => (
    <React.Fragment>
      { plans && plans.map((plan, index) => (
        <div className="col-25" key={index}>
          <EledoPricingPlan plan={plan} showButton={index > 0} planButton={
            (subscribedLevel !== undefined &&
              (index > 0 || subscribedLevel !== 0
                ? <PlanButton planIndex={index} currentLevel={subscribedLevel}/>
                : <div className={styles.buttonPlaceholder}>&nbsp;</div>)) || <div className={styles.buttonPlaceholder}>&nbsp;</div>
          }/>
        </div>
      )) }
    </React.Fragment>
  );

  const renderEnterprise = () => (
    <>
      { hasCustomPlan && customPlan !== undefined &&
        <div className={classnames("col-40", styles.EnterprisePlan)}>
          <EledoPricingPlan plan={customPlan} showButton={true} planButton={
            (subscribedLevel !== null) && <PlanButton planIndex={customPlan.id} currentLevel={subscribedLevel}/>
          }/>
        </div>
      }
      { hasCustomPlanNext && customPlanNext !== undefined &&
        <div className={classnames("col-40", styles.EnterprisePlan)}>
          <EledoPricingPlan plan={customPlanNext} showButton={true} planButton={
            (subscribedLevel !== null) && <PlanButton planIndex={customPlanNext.id} currentLevel={subscribedLevel}/>
          }/>
        </div>
      }

      { !hasCustomPlan && !hasCustomPlanNext &&
        <div className={classnames("col-40", styles.EnterprisePlan)}>
          <EledoPricingPlan plan={{name:"Custom plan", price: "Individual", documents: "5 000+",templates:"27+", support:"Dedicated team"}} showButton={true} planButton={
            <div className="text-center" style={{margin: "1rem"}}>
              <Link to="/helpdesk" className="w-button button outline" style={{width: "80%"}}>Contact</Link>
            </div>}/>
        </div>
      }
    </>
  );

  const renderOverquota = () =>
    plans && customPlan ? (
      <div className="container section section-small" style={{marginBottom: "3rem"}}>
        <h1>Limits and Overquota Pricing</h1>

        <div className={styles.eleComparisonRow} style={{marginTop: "2rem"}}>
          <div className={styles.eleColWide}/>
          {plans.map(p => <div key={p.id}><strong>{p.name}</strong></div>)}
          <div><strong>{customPlan.name}</strong></div>
        </div>
        <div className={styles.eleComparisonRow}>
          <div className={classnames(styles.eleColWide, "text-capitalize")}>
            <strong>documents</strong>
          </div>
          {plans.map(p => <div key={p.id}>{p.documents}</div>)}
          <div>{customPlan.documents}</div>
        </div>
        <div className={styles.eleComparisonRow}>
          <div className={styles.eleColWide}>
            <strong>per 25 documents</strong>
          </div>
          {plans.map(p => <div key={p.id}>{p.overquota ? p.oqPrice : "-"}</div>)}
          <div>{customPlan.overquota ? customPlan.oqPrice : "-"}</div>
        </div>
      </div>
    ) : null;

  return (
    <div className={styles.EledoPricing} data-testid="EledoPricing">
      <EledoMainPageTitle title="Pricing" subtitle=""/>

      { error && renderError() }
      {!error &&
        <div className="container section section-small">
          { !loading &&
            <div className="col-wrapper">
              { renderPlans() }
              { renderEnterprise() }
            </div>
          }
          { loading && <div className="flex-center"><EledoLoader/></div> }
        </div>
      }

      { !loading && !error &&
        renderOverquota()
      }
    </div>
  );
};

const PlanButton = ({currentLevel, planIndex}: {currentLevel: number, planIndex: number}) => {
  const color = currentLevel === planIndex ? "red" : (currentLevel > planIndex ? "yellow" : "");
  return <Link className={classnames("w-button", "button", color)}
                 style={{width: "8.5rem"}}
                 to={`/pricing/change/${planIndex}`}>
    { currentLevel < planIndex && "Upgrade" }
    { currentLevel > planIndex && "Downgrade" }
    { currentLevel === planIndex && "Cancel" }
  </Link>
}

export default EledoPricing;